// extracted by mini-css-extract-plugin
module.exports = {"container":"Staff_container__AImOf","tableContainer":"Staff_tableContainer__20bO9"};